
export default {
  name: 'ReasonsToUse',
};
